import { v1 as uuidv1 } from 'uuid';

export default class CartController {
	static itemsInCart = [];
	static customerCountry = null;
	static customerCityRef = null;
	static customerBranchRef = null;

	static addToCart(product) {
		console.log(product, this.itemsInCart);
		if (this.itemsInCart && this.itemsInCart.length > 0) {
			const existingProduct = this.itemsInCart.find(
				(item) =>
					item.id === product.id &&
					item.frame.name === product.frame.name &&
					item.size.id === product.size.id &&
					item.price === product.price
			);
			if (existingProduct) {
				existingProduct.quantity += 1;
				console.log('Product already in cart, increasing quantity');
				return;
			}
		}
		const newProduct = { ...product, quantity: 1 };
		newProduct.guid = uuidv1();
		console.log(newProduct.guid);
		this.itemsInCart.push(newProduct);
		console.log('addToCart', this.itemsInCart);
	}

	static removeFromCart(product) {
		const index = this.itemsInCart.findIndex(
			(item) => item.guid === product.guid
		);
		if (index !== -1) {
			this.itemsInCart.splice(index, 1);
		}
		console.log('removeFromCart', this.itemsInCart);
	}

	static getCartItems() {
		return this.itemsInCart;
	}

	static getDeliveryPrice() {
		// console.log(this.customerCountry);
		const item = STORECOUNTRIES.delivery[window.locale].find(
			(item) => item.value === this.customerCountry
		);
		console.log(item);
		// console.log(STORECOUNTRIES.delivery[window.locale][this.customerCountry]);
		return item ? item['price'] : 0;
	}

	static getDeliveryPriceString() {
		// return window.locale === 'ua' ? '0 грн.' : '$0.00';
		const deliveryPrice = this.getDeliveryPrice();
		const priceString = deliveryPrice; // convert to string with 2 decimal places
		const priceText =
			window.locale === 'ua'
				? `${priceString} грн.`
				: `$${(priceString / 100).toFixed(2)}`;
		return priceText;
	}

	static getSubtotalPrice() {
		return this.itemsInCart.reduce((total, item) => {
			return total + item.price * item.quantity;
		}, 0);
	}

	static getSubtotalPriceString() {
		const total = this.getSubtotalPrice();
		const priceString = (total / 100).toFixed(2); // convert to string with 2 decimal places
		const priceText = `$${priceString}`;
		const priceTextUah = `${total} грн.`;
		if (window.locale === 'ua') {
			return priceTextUah;
		}
		return priceText;
	}

	static getTotalPrice() {
		return (
			this.itemsInCart.reduce((total, item) => {
				return total + item.price * item.quantity;
			}, 0) + this.getDeliveryPrice()
		);
	}

	static getTotalPriceString() {
		const total = this.getTotalPrice();
		console.log(total);
		const priceText = `$${(total / 100).toFixed(2)}`;
		const priceTextUah = `${total} грн.`;

		if (window.locale === 'ua') {
			return priceTextUah;
		}
		return priceText;
	}

	static getCustomerCountry() {
		if (this.customerCountry) {
			return this.customerCountry;
		}
	}

	static setCustomerCountry(country) {
		this.customerCountry = country;
		console.log('setCustomerCountry', this.customerCountry);
	}

	static setCustomerCityRef(cityRef) {
		this.customerCityRef = cityRef;
		console.log('setCustomerCityRef', this.customerCityRef);
	}
	static setCustomerBranchRef(branchRef) {
		this.customerBranchRef = branchRef;
		console.log('setCustomerBranchRef', this.customerBranchRef);
	}
	static getCustomerCityRef() {
		if (this.customerCityRef) {
			return this.customerCityRef;
		}
	}
	static getCustomerBranchRef() {
		if (this.customerBranchRef) {
			return this.customerBranchRef;
		}
	}
}
